import React from "react";

import { useTheme } from "../../../providers/ThemeContext";
import { SmallCardStyles } from "./SmallCardStyles";

type Props = {
  href: string;
  title: string;
  text: string;
  icon: React.ReactNode;
  tooltipTitle?: string;
  newTab?: boolean;
  /** Force text direction for LTR data (phone numbers, emails) inside an RTL page. */
  textDir?: "ltr" | "rtl";
};

export default function SmallCard({
  href,
  title,
  text,
  icon,
  tooltipTitle,
  newTab = true,
  textDir,
}: Props) {
  const { theme } = useTheme();
  const s = SmallCardStyles(theme);

  return (
    <a
      href={href}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noreferrer noopener" : undefined}
      style={s.cardLink as React.CSSProperties}
      aria-label={text}
      title={tooltipTitle ?? title}
    >
      <div style={s.icon}>{icon}</div>
      <div style={s.cardText}>
        <div style={s.cardSmall}>{title}</div>
        <span
          style={{ ...s.link, ...(textDir ? { textAlign: "start" as const } : {}) }}
          dir={textDir}
        >
          {text}
        </span>
      </div>
    </a>
  );
}
